import { computed } from 'vue';
import { useMedicalRecords } from '@/composables/use-medical-records';
import { useFixtures } from '@/composables/use-fixtures';
import { usePatient } from '@/composables/use-patients';
import { useEncounters } from '@/composables/use-encounters';
import { RECORD_TYPE, UPDATE_FIELDS, ORDER_TYPE } from './constants';
import { useFacilities } from '@/composables/use-facilities';
import { useDiagnosticTestMeasures } from '@/composables/use-diagnostic-test-measures';

export function useLaboratoryResults () {
  const {
    medicalRecords,
    create: createMedicalRecord,
    update: updateMedicalRecord,
    // list: listMedicalRecords,
    remove: removeMedicalRecord,
  } = useMedicalRecords();
  const {
    getICD10,
  } = useFixtures();
  const {
    getList: getTestMeasures,
  } = useDiagnosticTestMeasures();
  // const orders = ref([]);

  const { patient } = usePatient();
  const { encounter } = useEncounters();
  const { activeFacility } = useFacilities();

  const records = computed(() => {
    return medicalRecords.value.filter((record) => record.type === RECORD_TYPE)
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  });

  const orders = computed(() => {
    return medicalRecords.value.filter((record) => record.type === ORDER_TYPE)
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  });

  const searchICD = async (searchString) => {
    return getICD10(searchString).data;
  };

  const getPopulatedTests = async (tests) => {
    return await Promise.all(tests.map((test) => {
      return getTestMeasures(test);
    }));
  };

  // const getOrders = async () => {
  //   const query = {
  //     type: ORDER_TYPE,
  //     patient: patient?.value?.id,
  //   };
  //   await listMedicalRecords(query);
  //   orders.value = res;
  // };

  const submit = async (payload) => {
    if (payload?.id) {
      const id = payload.id;
      payload = Object.keys(payload).reduce((acc, key) => {
        if (UPDATE_FIELDS.includes(key)) {
          acc[key] = payload[key];
        }
        return acc;
      }, {});
      await updateMedicalRecord(id, payload);
    } else {
      payload.type = RECORD_TYPE;
      payload.encounter = encounter.value?.id;
      payload.patient = patient.value?.id;
      payload.facility = activeFacility.value?.id;
      await createMedicalRecord(payload);
    }
  };

  const remove = async ({ id }) => {
    await removeMedicalRecord(id);
  };

  return {
    medicalRecords,
    records,
    orders,
    searchICD,
    // getOrders,
    getPopulatedTests,
    submit,
    remove,
  };
}
